import { FETCH_ACCT_RECIPES_SUCCESS, FETCH_ACCT_RECIPES_BEGIN, FETCH_ACCT_RECIPES_FAILURE, RECIPE_SELECTED } from '../actions/acct_recipes_actions';

export default function (state = {}, action) {
  switch (action.type) {
    case FETCH_ACCT_RECIPES_SUCCESS:
      var res = [];
      action.payload.data.Data.forEach(function (cat) {
        res.push({"Type":"CATEGORY", "Name": cat.Category, "Key": cat.Category})
        cat.Recipes.forEach(function (rec) {
          rec["Type"] = "RECIPE";
          rec["Key"] = cat.Category + rec.Recipe_Id;
          res.push(rec);
        });
      });
      return { 
        ...state, 
        acct_recipe_list: res,
        acct_recipes_loading: false,
        acct_recipes_error: null
      };

    case FETCH_ACCT_RECIPES_BEGIN:
      return {
        ...state,
        acct_recipes_loading: true,
        acct_recipes_error: null
      };

    case FETCH_ACCT_RECIPES_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        acct_recipes_loading: false,
      };
  
    case RECIPE_SELECTED:
      console.log(action);
      return {
        ...state,
        current_recipe: action.payload
      };

    default:
      return state;
  }

}



// WEBPACK FOOTER //
// ./src/reducers/acct_recipes_reducer.js